(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ww-ugc-strip"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.dataset.wugReady) return;
      root.dataset.wugReady = '1';
      var track = root.querySelector('[data-wug-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.wug-card'));
      var arrows = root.querySelectorAll('[data-wug-dir]');

      function setSound(card, on) {
        var v = card.querySelector('video');
        v.muted = !on;
        card.classList.toggle('is-sound', on);
        card.querySelector('[data-wug-sound]').setAttribute('aria-pressed', on);
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var on = !card.classList.contains('is-sound');
          cards.forEach(function (c) { if (c !== card) setSound(c, false); });
          setSound(card, on);
          var v = card.querySelector('video');
          if (on) { v.currentTime = 0; }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target.querySelector('video');
            if (e.intersectionRatio >= 0.6) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
              setSound(e.target, false);
            }
          });
        }, { threshold: [0, 0.6] });
        cards.forEach(function (c) { io.observe(c); });
      }

      function updateArrows() {
        var max = track.scrollWidth - track.clientWidth - 2;
        arrows[0] && (arrows[0].disabled = track.scrollLeft <= 2);
        arrows[1] && (arrows[1].disabled = track.scrollLeft >= max);
      }
      arrows.forEach(function (b) {
        b.addEventListener('click', function () {
          var step = cards[0] ? cards[0].getBoundingClientRect().width + 16 : 300;
          track.scrollBy({ left: step * Number(b.dataset.wugDir), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function boot() { document.querySelectorAll('[data-wug-root]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
